import useTransientStore from "../data/transcientStore";
import { CLIENT_SETTING_KEYS } from "../constants/clientSettingKeys";

export const useAddressSystemFeatures = () => {
  const clientSystemSettings = useTransientStore(
    (state) => state.clientSystemSettings,
  );
  const getSettingAsBoolean = useTransientStore(
    (state) => state.getSettingAsBoolean,
  );

  // Subscribe to the settings map so feature flags recompute when it changes.
  void clientSystemSettings;

  return {
    // ── Settings ──────────────────────────────────────────────────────────
    hasSubscribers: getSettingAsBoolean(CLIENT_SETTING_KEYS.ENABLE_SUBSCRIBERS),
    hasDeputies: getSettingAsBoolean(CLIENT_SETTING_KEYS.ENABLE_DEPUTIES),
    hasContractCrews: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_CONTRACT_CREWS,
    ),
    hasContractMachines: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_CONTRACT_MACHINES,
    ),
    hasUserDefaults: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.FEATURE_USER_DEFAULTS,
    ),

    // ── City Object tabs ─────────────────────────────────────────────────
    hasDeviations: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_CO_TAB_DEVIATION,
    ),
    hasExceptionReports: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_CO_TAB_EXCEPTION_REPORT,
    ),
    hasSelfDelivery: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_CO_TAB_SELF_DELIVERY,
    ),
    hasMvr: getSettingAsBoolean(CLIENT_SETTING_KEYS.ENABLE_CO_TAB_MVR),
    hasActionHistory: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_CO_TAB_ACTION_HISTORY,
    ),


    // ── City Object Detail tabs ───────────────────────────────────────────
    hasContractMemo: getSettingAsBoolean(CLIENT_SETTING_KEYS.ENABLE_CO_TAB_CONTRACT_MEMO),
    hasStaraObjectFields: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.FEATURE_STARA_OBJECT_FIELDS,
    ),

    // ── Reports ───────────────────────────────────────────────────────────
    hasSearchPrintouts: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_SEARCH_PRINTOUTS,
    ),
    hasFiles: getSettingAsBoolean(CLIENT_SETTING_KEYS.ENABLE_FILES),
    hasSiteMeetingReport: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_SITE_MEETING_REPORT,
    ),
    hasAnnualSummary: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_ANNUAL_SUMMARY,
    ),
    hasInvoiceReport: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_INVOICE_REPORT,
    ),
    hasInvoicingReport: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_INVOICING_REPORT,
    ),
    hasContractDiaryReport: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_CONTRACT_DIARY_REPORT,
    ),
    hasToContractorReport: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_TO_CONTRACTOR_REPORT,
    ),
    hasUnitPrices: getSettingAsBoolean(CLIENT_SETTING_KEYS.ENABLE_UNIT_PRICES),
    hasOpenPowerBiSummaryReport: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_OPEN_POWERBI_SUMMARY_REPORT,
    ),
    hasDeductionRelease: getSettingAsBoolean(
      CLIENT_SETTING_KEYS.ENABLE_DEDUCTION_RELEASE,
    ),

    // ── Escape hatch for one-off checks ───────────────────────────────────
    hasFeature: (key: string) => getSettingAsBoolean(key),
  };
};

export default useAddressSystemFeatures;
